export const TESTIMONIALS = [
  {
    quote:
      "Vertex turned our raw footage into retention-ready cuts every single week. The pacing, the sound, the frames — our audience noticed the jump immediately.",
    name: "Team SSG Animation",
    company: "SSG Animation",
    role: "YouTube Partner Channel",
    avatarUrl: "",
    result: "",
  },
  {
    quote:
      "Any brief, any deadline — they scale from a tight edit turn to a full production crew without us worrying about a thing. It genuinely feels like an in-house studio.",
    name: "Team MagnatesMedia",
    company: "MagnatesMedia",
    role: "Business Documentaries",
    avatarUrl: "",
    result: "",
  },
  {
    quote:
      "From script to final master they handled everything. Communication was fast, revisions were painless, and the delivery hit every format we needed.",
    name: "Team Revenge Reborn",
    company: "Revenge Reborn",
    role: "Cinematic Storytelling",
    avatarUrl: "",
    result: "",
  },
  {
    quote:
      "The animation quality is miles above what we expected. They treated our budget like it was their own production.",
    name: "Team Dream Toon",
    company: "Dream Toon",
    role: "Animated Stories",
    avatarUrl: "",
    result: "",
  },
];
